/**
 *@德语
 *@params
 *@author WangPing
 *@date 2020-07-20
 */

export default {
  _not_interested_in_this_video: 'Sie interessieren sich nicht für dieses Video? %second%',
  _switch_one: 'Ein weiterer',
  _next_reward_text: 'Sehen Sie sich ein weiteres Video an',
  _next_reward_button: 'Schau jetzt',
}